import Emoji01 from '@/assets/emoji/emoji-01.webp?as=picture';
import Emoji02 from '@/assets/emoji/emoji-02.webp?as=picture';
import Emoji03 from '@/assets/emoji/emoji-03.webp?as=picture';
import Emoji04 from '@/assets/emoji/emoji-04.webp?as=picture';
import Emoji05 from '@/assets/emoji/emoji-05.webp?as=picture';
import Emoji06 from '@/assets/emoji/emoji-06.webp?as=picture';
import Emoji07 from '@/assets/emoji/emoji-07.webp?as=picture';
import Emoji08 from '@/assets/emoji/emoji-08.webp?as=picture';
import Emoji09 from '@/assets/emoji/emoji-09.webp?as=picture';
import Emoji10 from '@/assets/emoji/emoji-10.webp?as=picture';
import Emoji11 from '@/assets/emoji/emoji-11.webp?as=picture';
import Emoji12 from '@/assets/emoji/emoji-12.webp?as=picture';
import Emoji13 from '@/assets/emoji/emoji-13.webp?as=picture';
import Emoji14 from '@/assets/emoji/emoji-14.webp?as=picture';
import Emoji15 from '@/assets/emoji/emoji-15.webp?as=picture';
import Emoji16 from '@/assets/emoji/emoji-16.webp?as=picture';
import Emoji17 from '@/assets/emoji/emoji-17.webp?as=picture';
import Emoji18 from '@/assets/emoji/emoji-18.webp?as=picture';
import Emoji19 from '@/assets/emoji/emoji-19.webp?as=picture';
import Emoji20 from '@/assets/emoji/emoji-20.webp?as=picture';
import Emoji21 from '@/assets/emoji/emoji-21.webp?as=picture';
import Emoji22 from '@/assets/emoji/emoji-22.webp?as=picture';
import Emoji23 from '@/assets/emoji/emoji-23.webp?as=picture';
import Emoji24 from '@/assets/emoji/emoji-24.webp?as=picture';
import Emoji25 from '@/assets/emoji/emoji-25.webp?as=picture';
import Emoji26 from '@/assets/emoji/emoji-26.webp?as=picture';
import Emoji27 from '@/assets/emoji/emoji-27.webp?as=picture';
import Emoji28 from '@/assets/emoji/emoji-28.webp?as=picture';
import Emoji29 from '@/assets/emoji/emoji-29.webp?as=picture';
import Emoji30 from '@/assets/emoji/emoji-30.webp?as=picture';
import Emoji31 from '@/assets/emoji/emoji-31.webp?as=picture';
import Emoji32 from '@/assets/emoji/emoji-32.webp?as=picture';
import Emoji33 from '@/assets/emoji/emoji-33.webp?as=picture';
import Emoji34 from '@/assets/emoji/emoji-34.webp?as=picture';
import Emoji35 from '@/assets/emoji/emoji-35.webp?as=picture';
import Emoji36 from '@/assets/emoji/emoji-36.webp?as=picture';
import Emoji37 from '@/assets/emoji/emoji-37.webp?as=picture';
import Emoji38 from '@/assets/emoji/emoji-38.webp?as=picture';
import Emoji39 from '@/assets/emoji/emoji-39.webp?as=picture';
import Emoji40 from '@/assets/emoji/emoji-40.webp?as=picture';
import Emoji41 from '@/assets/emoji/emoji-41.webp?as=picture';
import Emoji42 from '@/assets/emoji/emoji-42.webp?as=picture';
import Emoji43 from '@/assets/emoji/emoji-43.webp?as=picture';
import Emoji44 from '@/assets/emoji/emoji-44.webp?as=picture';
import Emoji45 from '@/assets/emoji/emoji-45.webp?as=picture';
import Emoji46 from '@/assets/emoji/emoji-46.webp?as=picture';
import Emoji47 from '@/assets/emoji/emoji-47.webp?as=picture';
import Emoji48 from '@/assets/emoji/emoji-48.webp?as=picture';
import Emoji49 from '@/assets/emoji/emoji-49.webp?as=picture';

export const emoticons: Record<string, Picture> = {
  '[e01]': Emoji01,
  '[e02]': Emoji02,
  '[e03]': Emoji03,
  '[e04]': Emoji04,
  '[e05]': Emoji05,
  '[e06]': Emoji06,
  '[e07]': Emoji07,
  '[e08]': Emoji08,
  '[e09]': Emoji09,

  '[e010]': Emoji10,
  '[e011]': Emoji11,
  '[e012]': Emoji12,
  '[e013]': Emoji13,
  '[e014]': Emoji14,
  '[e015]': Emoji15,
  '[e016]': Emoji16,
  '[e017]': Emoji17,
  '[e018]': Emoji18,
  '[e019]': Emoji19,

  '[e020]': Emoji20,
  '[e021]': Emoji21,
  '[e022]': Emoji22,
  '[e023]': Emoji23,
  '[e024]': Emoji24,
  '[e025]': Emoji25,
  '[e026]': Emoji26,
  '[e027]': Emoji27,
  '[e028]': Emoji28,
  '[e029]': Emoji29,

  '[e030]': Emoji30,
  '[e031]': Emoji31,
  '[e032]': Emoji32,
  '[e033]': Emoji33,
  '[e034]': Emoji34,
  '[e035]': Emoji35,
  '[e036]': Emoji36,
  '[e037]': Emoji37,
  '[e038]': Emoji38,
  '[e039]': Emoji39,

  '[e040]': Emoji40,
  '[e041]': Emoji41,
  '[e042]': Emoji42,
  '[e043]': Emoji43,
  '[e044]': Emoji44,
  '[e045]': Emoji45,
  '[e046]': Emoji46,
  '[e047]': Emoji47,
  '[e048]': Emoji48,
  '[e049]': Emoji49,
};
